import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import {AppDataService, ConfigService, PromosService} from 'app/services';
import { FieldTypeEnum, Promo, PromoAvailableTypeEnum, PromoTypeEnum, ServiceTypeEnum } from 'app/models';
import * as moment from 'moment';
import { Utils } from 'app/utils';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { PromoStatus } from 'app/models/enums/promo-status.enum';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'service-type-promotions',
    templateUrl: './service-type-promotions.component.html',
    styleUrls: ['./service-type-promotions.component.scss'],
    providers: [MessageService]
})
export class ServiceTypePromotionsComponent implements OnInit {

    @Input()
    public serviceTypeId!: ServiceTypeEnum;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public isMerchant: boolean = false;
    public merchantId: number = 0;

    //---------------Promos----------------------
    public promoTypeFilterArray = [
        { id: null, name: 'All' },
        { id: PromoTypeEnum.FreeDelivery, name: 'Free Delivery' },
        { id: PromoTypeEnum.Referral, name: 'Referral' },
        { id: PromoTypeEnum.PercentageDiscount, name: 'Percentage Discount' },
        { id: PromoTypeEnum.FixedAmountDiscount, name: 'Fixed Amount Discount' },
        { id: PromoTypeEnum.DeliveryFeeDiscount, name: 'Delivery Fee Discount' },
        { id: PromoTypeEnum.FreeItemPromo, name: 'Free Item Promo' },
    ];

    public promoAvailableTypeFilterArray = [
        { id: null, name: 'All Promos' },
        { id: PromoAvailableTypeEnum.None, name: 'None' },
        { id: PromoAvailableTypeEnum.AllCustomers, name: 'All Customers' },
        { id: PromoAvailableTypeEnum.NewCustomers, name: 'New Customers' },
        { id: PromoAvailableTypeEnum.ReturningCustomers, name: 'Existing Customers' },
        { id: PromoAvailableTypeEnum.CustomUsers, name: 'Custom Users' },
    ];

    public promoStatusFilterArray = [
        { id: null, name: 'All' },
        { id: PromoStatus.Upcoming, name: 'Upcoming' },
        { id: PromoStatus.Ongoing, name: 'Ongoing' },
        { id: PromoStatus.Completed, name: 'Completed' },
    ];

    public promoIsActiveArray = [
        { id: null, name: 'All' },
        { id: true, name: 'Active' },
        { id: false, name: 'Inactive' },
    ];

    public promos: any = null;
    public cols: any[] = [
        { field: 'Id', header: 'Promo ID', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'Id', active: false },
        { field: 'PromoTypeText', header: 'Promo Type', width: '20%', fieldType: FieldTypeEnum.Dropdown,
            model: 'PromoTypeId', options: this.promoTypeFilterArray, active: false },
        { field: 'Code', header: 'Promo Code', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'Code', active: false },
        { field: 'Name', header: 'Promo Name', width: '20%', fieldType: FieldTypeEnum.Inputs, model: 'Name', active: false },
        { field: 'UseAmount', header: 'Dis. Value', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'UseAmount', active: false },
        { field: 'MinSpend', header: 'Min. Spend', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'MinSpend', active: false },
        { field: 'StartedAt', header: 'Start', width: '150px', fieldType: FieldTypeEnum.Calendar, model: 'StartedAt', active: false },
        { field: 'ValidUntil', header: 'End', width: '150px', fieldType: FieldTypeEnum.Calendar, model: 'ValidUntil', active: false },
        { field: 'PromoAvailableText', header: 'Customers', width: '20%', fieldType: FieldTypeEnum.Dropdown,
			options: this.promoAvailableTypeFilterArray, model: 'PromoAvailableType', active: false
		},
		{ field: 'UseCount', header: 'Redeemed', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'UseCount', active: false },
        { field: 'MaxUseCount', header: 'Max Redm.', width: '20%', fieldType: FieldTypeEnum.InputNumber, model: 'MaxUseCount', active: false },
        { field: 'Status', header: 'Status', width: '20%', fieldType: FieldTypeEnum.Dropdown, model: 'Status', options: this.promoStatusFilterArray,
            disableSort: true,  showSortIcon: false, active: false },
        { field: 'IsActive', header: 'IsActive', width: '20%', fieldType: FieldTypeEnum.Dropdown, model: 'IsActive', options: this.promoIsActiveArray, active: false }
    ];
    public defaultCols = this.cols.map(x => x);

    public showSideBar: boolean = false;
    public promoId: number = 0;
    public visibleSideBarAddUpdate: boolean = false;

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    private searchTimer: number = 0;

    public loading: boolean = false;
    public tableName: string = 'all-promotions';
    public fieldTypeEnum = FieldTypeEnum;

    public showAddEditPromotionSideBar: boolean = false;
    public visiblePartnerMarketingFilterPromotion: boolean = false;
    public filter: any = {
        Id: null,
        PromoTypeId: null,
        Code: '',
        Name: '',
        UseAmount: null,
        MinSpend: null,
        StartedAt: null,
		ValidUntil: null,
		UseCount: null,
        MaxUseCount: null,
        IsActive: null,
        Skip: null,
        Take: this.rowsPerPage,
        SortField: this.sortField,
        SortOrder: this.sortOrder,
        TimeZoneOffset: Utils.getTimezoneOffset()
    };

    public selectPromoId: number = 0;
    public selectPromoTypeId!: PromoTypeEnum;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_marketing' }, { label: 'Marketing' }, { label: 'Xpress App Marketing' },
        { label: 'Promotions' }, { label: 'All Promotions' }];

    constructor(private messageService: MessageService, public appData: AppDataService,
                public promosService: PromosService, public configService: ConfigService){
        this.merchantId = parseInt(this.appData.authData.MerchantId, 10);
        this.isMerchant = this.appData.isMerchant();
    }

    ngOnInit(): void {
    }

    public handlePromoLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getPromos(skip);
    }

    public handleHeaderFilterChange() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getPromos(0);
            this.searchTimer = 0;
        }, 1500);
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public getPromos(skip: number, filterObj: any = undefined) {
        this.loading = true;

        let dto = {};
        if (filterObj) {
            dto = {
                PromoTypeId: filterObj.PromoTypeId,
                PromoAvailableType: filterObj.PromoAvailableType,
                StartedAt: filterObj.StartedAt,
                ValidUntil: filterObj.ValidUntil,
                IsActive: filterObj.IsActive,
                Status: filterObj.Status,
                ClientLocationType: this.appData.getClientLocationType(),
                Skip: skip,
                Take: this.rowsPerPage,
                SortField: this.sortField,
                SortOrder: this.sortOrder,
                TimeZoneOffset: Utils.getTimezoneOffset()
            };
        }
        else {
            dto = {
                Id: this.filter.Id,
                PromoTypeId: this.filter.PromoTypeId,
                PromoAvailableType: this.filter.PromoAvailableType,
                Code: this.filter.Code,
                Name: this.filter.Name,
                UseAmount: this.filter.UseAmount,
                MinSpend: this.filter.MinSpend,
                StartedAt: this.filter.StartedAt,
				ValidUntil: this.filter.ValidUntil,
				UseCount: this.filter.UseCount,
                MaxUseCount: this.filter.MaxUseCount,
                IsActive: this.filter.IsActive,
                Status: this.filter.Status,
                ClientLocationType: this.appData.getClientLocationType(),
                Skip: skip,
                Take: this.rowsPerPage,
                SortField: this.sortField,
                SortOrder: this.sortOrder,
                TimeZoneOffset: Utils.getTimezoneOffset()
            };
        }

        this.promosService.getPromos(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;

                this.promos = data.Items.map((x: Promo) => {
                    x.StartedAt = Utils.utcToLocalDate(x.StartedAt);
                    x.ValidUntil = Utils.utcToLocalDate(x.ValidUntil);

                    x.StartedAtStr = moment(x.StartedAt).format('DD MMM YYYY');
                    x.ValidUntilStr = moment(x.ValidUntil).format('DD MMM YYYY');
                    x.Status = this.getPromoStatus(x.StartedAt, x.ValidUntil);

                    if (x.UseAmount) {
                        x.DiscountValueStr = String.fromCharCode(8369) + ' ' + x.UseAmount.toString();
                    }
                    else if (x.UsePercent) {
                        x.DiscountValueStr = x.UsePercent.toString() + ' %';
                    }
                    else {
                        x.DiscountValueStr = String.fromCharCode(8369) + ' 0';
                    }

                    if (x.MinSpend) {
                        x.MinSpendStr = String.fromCharCode(8369) + ' ' + x.MinSpend.toString();
                    }
                    else {
                        x.MinSpendStr = String.fromCharCode(8369) + ' 0';
                    }
                    if (!x.MaxUseCount) {
                        x.RedemptionsStr = 'unlimited';
                    }
                    else {
                        x.RedemptionsStr = x.MaxUseCount.toString();
                    }
                    return x;
                });

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public getPromoStatus(startedAt: Date | null, validUntil: Date | null) {
        const currentTime = new Date();

        if (!startedAt || ! validUntil) {
            return '';
        }

        if (startedAt > currentTime) {
            return PromoStatus.Upcoming;
        }
        else if (startedAt < currentTime && validUntil > currentTime) {
            return PromoStatus.Ongoing;
        }
        else if (validUntil < currentTime) {
            return PromoStatus.Completed;
        }

        return '';
    }

    getPromoStatusStyle(startedAt: Date | null, validUntil: Date | null) {
        switch (this.getPromoStatus(startedAt, validUntil)) {
            case PromoStatus.Upcoming: return 'promo-upcoming';
            case PromoStatus.Ongoing: return 'promo-ongoing';
            case PromoStatus.Completed: return 'promo-completed';
            default: return '';
        }
    }

    public updatePromoIsActive(promo: any) {
        const dto = {
            PromoId: promo.Id,
            IsActive: promo.IsActive
        };
        this.promosService.updatePromoIsActive(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data updated successfully' });
                this.getPromos(0);
            });

    }

    public switchPromo(promo: any) {
        this.updatePromoIsActive(promo);
    }

    public openMerchantCreatePromotionSideBar() {
        this.showAddEditPromotionSideBar = true;
    }
    changedShowAddEditPromotionSideBarEmit(value: any) {
        this.showAddEditPromotionSideBar = value;
        this.selectPromoId = 0;
        this.selectPromoTypeId = 0;
    }

    public openMerchanteditPromotionSideBar(promoId: number, promoTypeId: PromoTypeEnum) {
        this.selectPromoId = promoId;
        this.selectPromoTypeId = promoTypeId;
        this.showAddEditPromotionSideBar = true;
    }

    public openPartnerMarketingFilterPromotionSideBar() {
        this.visiblePartnerMarketingFilterPromotion = true;
    }
    changedShowPartnerMarketingFilterPromotionSideBarEmit(value: boolean) {
        this.visiblePartnerMarketingFilterPromotion = value;
    }

    //методы для редактирования промо
    public handleDetailPopupClick(promo: any): void {
        this.selectPromoId = promo.Id;
        this.showSideBar = true;
    }

    changedShowSideBarEmit(value: any) {
        this.showSideBar = value;
    }

    public showModalSideBarAddUpdate(promo: any) {
        if (promo !== null) {
            this.selectPromoId = promo.Id;
        } else {
            this.selectPromoId = 0;
        }
        this.showAddEditPromotionSideBar = true;
    }

    changedVisibleSiderBarAddUpdateEmit(value: any) {
        this.visibleSideBarAddUpdate = value;
    }
}
